/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'check': {
    width: 45,
    height: 45,
    viewBox: '0 0 45 45',
    data: `<defs><clipPath id="svgicon_check_a"><path pid="0" d="M0 0h45v45H0z"/></clipPath></defs><g clip-path="url(#svgicon_check_a)"><path pid="1" d="M2.586 21.027l14.523 14.524 25.477-25.477" _fill="none" _stroke="currentColor" stroke-width="2"/></g>`
  }
})
/* tslint:enable */
